var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import IconPill from '../icon-pill/IconPill.js';
import IconPillGroupStyle from './IconPillGroupStyle.js';
/**
 * Icon Pill class.
 */
export default class IconPillGroup extends KompisElement {
    constructor() {
        super(...arguments);
        // Label for the icon pill group to set as an aria-label for accessibility reasons.
        this.ariaLabel = null;
    }
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${IconPillGroupStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<div role="group" aria-label="${this.ariaLabel || ''}" class="container">
				<slot @keydown="${(event) => this.onKeyDown(event)}"></slot>
			</div>
		`;
    }
    /**
     * When key down.
     *
     * @param event Keyboard event.
     */
    onKeyDown(event) {
        switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
                event.preventDefault();
                this.changeButtonFocus(+1);
                break;
            case 'ArrowLeft':
            case 'ArrowUp':
                event.preventDefault();
                this.changeButtonFocus(-1);
                break;
        }
    }
    changeButtonFocus(increment) {
        const iconPills = Array.from(this.children)
            .filter((child) => child instanceof IconPill)
            .filter((node) => !node.disabled);
        const currentlyFocusedIconPill = iconPills.find((element) => element.matches(':focus-within'));
        if (!currentlyFocusedIconPill) {
            return;
        }
        const index = iconPills.indexOf(currentlyFocusedIconPill);
        const iconPill = iconPills[(iconPills.length + index + increment) % iconPills.length];
        iconPill.shadowRoot?.querySelector('div')?.focus();
    }
}
__decorate([
    property({ type: String })
], IconPillGroup.prototype, "ariaLabel", void 0);
__decorate([
    property({ type: Object, required: true })
], IconPillGroup.prototype, "theme", void 0);
//# sourceMappingURL=IconPillGroup.js.map